import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddbBlogform.css";
import Swal from "sweetalert2";
import { FaTimes } from "react-icons/fa";

const ViewCareerDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const careerData = location.state?.careerProbsData || {};

  return (
    <div className="modal-overlay  admin_modal_preview create_career_details">
      <div className="custom-modal-content">
        <div className="col-md-12 custom-modal-title text-left">
          <h2 className="mt-0">Job Details</h2>
        </div>
        <div className="custom-form-group mt-4 closepreview text-right">
          <button
            type="button"
            className="custom-btn-cancel"
            onClick={() => navigate("/create-careers")}
          >
            <FaTimes />
          </button>
        </div>
        <div className="career-details">
          <div className="col-md-12 form-group">
            <label>Job Title</label>
            <span>:</span>
            <p> {careerData.jobTitle} </p>
          </div>

          <div className="col-md-12 form-group">
            <label>Company Name</label>
            <span>:</span>
            <p> {careerData.companyName}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Location</label>
            <span>:</span>
            <p> {careerData.location}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Job Type</label> <span>:</span>
            <p>{careerData.jobType}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Experience</label>
            <span>:</span> <p> {careerData.experience} years</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Department</label>
            <span>:</span> <p> {careerData.department}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Shift Time</label> <span>:</span>
            <p> {careerData.shiftTime}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Working Days</label> <span>:</span>
            <p> {careerData.workingDays} days</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Vacancies</label>
            <span>:</span> <p>{careerData.vacancy}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Salary</label>
            <span>:</span>
            <p> {careerData.salary}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Job Description</label>
            <span>:</span> <p> {careerData.jobDescription}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Benefits</label> <span>:</span>
            <p> {careerData.benefits}</p>
          </div>
          <div className="col-md-12 form-group">
            <label>Department Notes</label>
            <span>:</span>
            <p> {careerData.departmentNotes}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCareerDetails;
